export const ePages = {
  SUBSCRIPTIONS_INFO_PAGE: 'customerSubscriptions',
  PRODUCT_PURCHASE_PAGE: 'orderDetails',
  PRODUCT_EXTENDED_INFO_PAGE: 'extendedInformation',
  DELIVERY_PAGE: 'deliveryDetails',
  TECHNICIAN_SLOTS_PAGE: 'DeliveryTechnicianSlots',
  CHECKOUT_PAGE: 'Checkout',
  SUCCESS_PAGE: 'OrderSuccess',
  ERROR_PAGE: 'error',
};

export const eErrors = {
  REQUIRED_EQUIPMENT_NOT_FOUND: '66',
  UPDATE_PAYMENT_METHOD_REQUIRED: '67',
  SETTLE_DEBT_REQUIRED: '68',
  UPDATE_PAYMENT_METHOD_AND_SETTLE_DEBT_REQUIRED: '69',
  FINANCIAL_ISSUE: '70',
  TV_SERVICE_NOT_FOUND: '71',
};
